import placeholder from "../../assets/images/image.png";
const Image = ({ src, alt, ...props }) => {

    return (
        <img
            src={src}
            loading="lazy"
            alt={alt || Math.random()}
            onError={(e) => { e.target.src = placeholder }}
            {...props}
        />
    );
};

export default Image;